import { request } from '@meta-vue/util'
import packageInfo from '../../../package.json'
import { getUserI18n } from '../../util/tools'

const Config = process.env
// 获取用户权限
export default async function getUserPermission() {
  try {
    const responseData = await request(`${Config.VUE_APP_PM}qmove-oa-permission-app/exportV2/queryMenuTree`, {
      method: 'GET',
      silent: true,
      networkFirst: 'queryMenuTree_menus',
      getter: {
        successCode: 200,
        message: 'message',
        data: 'data',
        code: 'code'
      },
      params: {
        category: packageInfo.PM_POWER_ID,
        flag: '1',
        qlan: JSON.parse(getUserI18n()).language,
        regionCode: JSON.parse(getUserI18n()).country
      }
    })

    // if (responseData) {
    return {
      userMenus: responseData || [],
      auth: getPermissionList(responseData || [])
    }
    // }
    // 到此处说明没有权限数据
    // errorHandler(CONST.noRouteAuth, '可能没有访问权限， 请检查权限后刷新重试！')
  } catch (e) {
    console.error(e)
    // errorHandler(CONST.noRouteAuth, '权限服务异常， 请刷新重试！')
  }
}

// 过滤权限接口数据,生成可访视的路由列表
function getPermissionList(permission) {
  return permission.reduce((merged, platform) => merged.concat(...flatPermission(platform)).filter(it => it.path), [])
}

// 展平权限列表
function flatPermission(item) {
  if (!item) {
    return []
  }
  const { child, href, ...others } = item
  return [
    {
      ...others,
      path: formatPath(href)
    }
  ].concat(...(child ? child.map(flatPermission) : []))
}
function formatPath(href) {
  return (href || '').replace('#', '').toLocaleLowerCase()
}
